import type { DesignListItem } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { DeleteMyDesignButton } from '@/features/my-design/delete';
import { DuplicateMyDesignButton } from '@/features/my-design/duplicate';

interface MyDesignToolsProps {
  readonly design: DesignListItem;
}

/** 카드 이름 줄 오른쪽의 작은 아이콘 — 복제·삭제(2026-10-19 결정). 판매 중지 상품은 서버가 복제를 막으므로 삭제만 둔다. */
export const MyDesignTools = ({ design }: MyDesignToolsProps): ReactElement => (
  <>
    {design.productStatus === 'PUBLISHED' ? <DuplicateMyDesignButton design={design} /> : null}
    <DeleteMyDesignButton design={design} />
  </>
);
